// Modules
import styled from "styled-components"

// Constants
import colors from "~constants/colors"

export const RuleLogicPicker = styled.div`
  align-items: center;
  display: flex;

  > span {
    background-color: ${colors.gray2};
    border-radius: 4px;
    display: inline-block;
    font-size: 12px;
    height: 30px;
    line-height: 30px;
    padding: 0 10px;
  }

  > div {
    margin: 0;

    &:first-of-type {
      margin: 0 15px;
    }
  }
`

export const HoldingsPeriodSelector = styled.div`
  > .title {
    color: ${colors.gray4};
    letter-spacing: 0.76px;
    line-height: 100%;
    margin-bottom: 10px;
  }

  > .period {
    background-color: ${colors.cerulean};
    border-radius: 4px;
    color: white;
    display: inline-block;
    font-size: 12px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    width: 60px;
  }

  > .info {
    color: ${colors.gray4};
    font-family: "Lato";
    font-size: 12px;
    font-style: italic;
    margin-top: 5px;
  }
`
